import React, { useState, FC } from "react";

import { useStore } from "react-stores";
import {
  downloadGlobalStore,
  errorStore,
  globalStore,
  setGlobalStoreFromFile,
} from "../globalStore";
import { useAnchorWallet, useWallet } from "@solana/wallet-adapter-react";
import NodeSelector from "./node-selector";
import {
  deleteAction,
  runFlow,
  tryPartialBuild,
} from "../utils/malloc";
import { Connection } from "@solana/web3.js";

const FlowControls = (props: { connection: Connection }) => {
  const state = useStore(globalStore);
  const error = useStore(errorStore);
  const wallet = useAnchorWallet();

  // Control panel loaders
  const [loadingCompileAndRun, setLoadingCompileAndRun] = useState(false);
  const [rerunningFromFailed, setRerunningFromFailed] = useState(false);
  const [loadingBuild, setLoadingBuild] = useState(false);
  // End control panel loaders
  const runFlowWrapper = (
    rerunFromFailed: boolean,
    loadingFn: (v: boolean) => void
  ) => {
    if (!state.malloc || !wallet) {
      alert("Please connect your wallet before running a flow");
      return;
    }
    const rerunFromAction = rerunFromFailed ? error.failedAction : undefined;
    if (rerunningFromFailed && !rerunFromAction) {
      alert(
        "You can only rerun from a failure if a previous failure has occurred"
      );
      return;
    }
    console.log(rerunFromAction);
    runFlow(state, wallet, loadingFn, rerunFromAction);
  };

  const clearAll = () => {
    if (
      window.confirm(
        "Clearing the flow is (currently) irreversible. Are you sure?"
      )
    ) {
      const allActions = Object.keys(state.construction.actionDatas);
      for (let i = 0; i < allActions.length; i++) {
        deleteAction(allActions[i]);
      }
    } else {
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", justifyContent: "left", gap: "1rem" }}>
        <NodeSelector />

        <button className="controls" onClick={() => clearAll()}>
          Clear All
        </button>

      </div>
      <div style={{ display: "flex", justifyContent: "right", gap: "1rem" }}>
        <button className="controls" onClick={() => setGlobalStoreFromFile()}>
          Import
        </button>
        <button className="controls" onClick={() => downloadGlobalStore()}>
          Export
        </button>
        <button
          className="controls"
          onClick={() => {
            setLoadingBuild(true);
            tryPartialBuild(state).finally(() => setLoadingBuild(false));
          }}
          disabled={loadingBuild}
        >
          {loadingBuild ? "Building..." : "Build"}
        </button>
        <button
          className="controls"
          disabled={loadingCompileAndRun}
          onClick={() => runFlowWrapper(false, setLoadingCompileAndRun)}
        >
          {loadingCompileAndRun ? "Running..." : "Build and Run"}
        </button>

        {error.failedAction && (
          <button
            className="controls"
            disabled={loadingCompileAndRun}
            onClick={() => runFlowWrapper(true, setRerunningFromFailed)}
          >
            {rerunningFromFailed ? "Rerunning..." : "Rerun failed"}
          </button>
        )}
      </div>
    </div>
  );
};

export default FlowControls;
